import { Api } from "src/utils/api";
import { MATH_BASE_URL } from "./mathUrl";
import { WIDGET_METRIC_KEYS } from "./math.const";

export type WidgetMetrics = Record<(typeof WIDGET_METRIC_KEYS)[number], number>;

export type WidgetMetricKey = keyof WidgetMetrics;

export class MathService extends Api {
  public static instance: MathService;

  public constructor() {
    super(MATH_BASE_URL);
  }
}
